import styled from 'styled-components';

// width: ${({ languages }) => (languages ? '99' : 'unset')};

export const Wrapper = styled.div``;
export const Labels = styled.div<{ inputFields?: number }>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  & > h6:last-child {
    margin-right: ${({ inputFields }) => (inputFields ? `calc(48% - ${inputFields * 7}%)` : '48%')};
  }
`;
export const Row = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 4px;

  & > div {
    margin-top: 0 !important;
    flex: 1;
    margin-right: 4px;
  }
`;
export const RemoveButton = styled.div`
  width: 48px;
  height: 48px;
  border: 1px solid var(--colorBlueGray200);
  border-radius: 4px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  flex: unset !important;
  margin-right: 0 !important;
  cursor: pointer;
  background-color: var(--colorWhite);
`;

export const AddRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-top: 16px;
  cursor: pointer;
`;
